// responsive
$(document).ready(function(){
	siteResize();
	$(window).resize(function(){
		siteResize();
	});

	function siteResize(){
		windowHeight = window.innerHeight;
		$("#main").css({ "margin-top": windowHeight });
	}
});


$(function() {
	// フェードイン
	$('.inviewfadeIn').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).stop().addClass('fadeIn');
	/*
		} else {
			$(this).stop().removeClass('fadeIn');
	*/
		}
	});

	// 上へスライド
	$('.inviewUp').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).stop().addClass('Up');
	/*
		} else {
			$(this).stop().removeClass('Up');
	*/
		}
	});
	// ズームイン
	$('.inviewzoomIn').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).stop().addClass('zoomIn');
	/*
		} else {
			$(this).stop().removeClass('zoomIn');
	*/
		}
	});
	// フェードインしながら上へスライド	 
	$('.inviewfadeInUp').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).stop().addClass('fadeInUp');
	/*
		} else {
			$(this).stop().removeClass('fadeInUp');
	*/
		}
	});
	// フェードインしながら右へスライド	 
	$('.inviewfadeInRight').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).stop().addClass('fadeInRight');
	/*
		} else {
			$(this).stop().removeClass('fadeInUp');
	*/
		}
	});
	// フェードインしながら左へスライド	 
	$('.inviewfadeInLeft').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$(this).stop().addClass('fadeInLeft');
	/*
		} else {
			$(this).stop().removeClass('fadeInUp');
	*/
		}
	});

	// header 
	$('#header').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$('#header div h2').addClass('dummy').delay(2000).queue(function(){
				$('#header div h2').stop().addClass('fadeInUp').delay(200).queue(function(){
					$('#header div p.p1').stop().addClass('fadeInUp').delay(200).queue(function(){
						$('#header div p.p2').stop().addClass('fadeInUp');
					});
				});
			});
		}
	});

	// footer 
	$('#footer ul.banner').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
		if (isInView) {
			$('#footer ul.banner li:eq(0)').stop().addClass('fadeInUp').delay(200).queue(function(){
				$('#footer ul.banner li:eq(1)').stop().addClass('fadeInUp').delay(200).queue(function(){
					$('#footer ul.banner li:eq(2)').stop().addClass('fadeInUp');
				});
			});
		}
	});
});
